import React, { ChangeEvent } from 'react';
import {
  Copy,
  SvgCheck,
  Flex,
  Stack,
  Square,
  SvgMinus,
} from '@grubhubprod/gh-cookbook-react';
import classnames from 'classnames';

interface ICheckboxProps {
  id: string;
  name: string;
  label?: string;
  disabled?: boolean;
  isBlockDisplay?: boolean;
  isMultipleSelection?: boolean;
  ariaLabel?: string;
  cancelLabelBottomMargin?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  value?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, ICheckboxProps>(
  function checkboxElement(
    {
      id,
      name,
      label,
      disabled,
      isBlockDisplay,
      isMultipleSelection,
      ariaLabel,
      cancelLabelBottomMargin,
      onChange,
      checked,
      value,
    },
    ref
  ) {
    return (
      <label
        data-testid={`checkbox-${id}`}
        htmlFor={id}
        className={classnames('checkbox_checkboxLabel', {
          checkbox_disabled: disabled,
          checkbox_block: isBlockDisplay,
          checkbox_cancelLabelBottomMargin: cancelLabelBottomMargin,
        })}
      >
        <Flex alignItems="center">
          <Stack x="x-sm">
            <input
              type="checkbox"
              ref={ref}
              name={name}
              id={id}
              disabled={disabled}
              className="checkbox_hiddenCheckboxInput"
              onChange={onChange}
              checked={checked}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(value && {
                value,
              })}
            />
            <Square
              className="checkboxInput"
              border="2px solid"
              borderColor="darkLine"
              width="20px"
              height="20px"
              borderRadius="4px"
            >
              <Flex
                className="checkboxIcon"
                justifyContent="center"
                alignItems="center"
                color="invertedPrimaryText"
              >
                {!isMultipleSelection ? <SvgCheck /> : <SvgMinus />}
              </Flex>
            </Square>
          </Stack>
          {label ? (
            <Copy variant="body">{label}</Copy>
          ) : (
            <span aria-label={ariaLabel} />
          )}
        </Flex>
      </label>
    );
  }
);
